var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0)","z-index":"99"}},[_c('img',{staticStyle:{"z-index":"100","margin-left":"50%","margin-top":"18%","width":"85px"},attrs:{"src":"image/loading-load.gif"}})])
}]

export { render, staticRenderFns }